import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id E9F0AC95-A660-4FB1-BE5D-20153B709E15
 * name power-socket-uk
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-socket-uk.svg
 * tags
 * - Home Automation 
 */
export const PowerSocketUkIcon = createSvgIcon(<><path d="M4 2A2 2 0 0 0 2 4V20A2 2 0 0 0 4 22H20A2 2 0 0 0 22 20V4A2 2 0 0 0 20 2H4M4 4H20V20H4V4M11 7V11H13V7H11M6 14.75V17H9.5V14.75H6M14.5 14.75V17H18V14.75H14.5Z" /></>, 'PowerSocketUkIcon');
export default PowerSocketUkIcon